export default __webpack_public_path__ + "static/media/ic_portugal.9f7d1c2d.svg";